import axios from "axios";

import * as Error from "../isp._comun/servicios/Errores";
import ServicioAPI from "../isp._comun/servicios/ServicioAPI";
// import { keyDeErrorApi } from "../../_comun/reductores/Constantes";
// import { StatusCodes } from "http-status-codes";

export default class ServicioDeQueryDeUnClienteAFacturar extends ServicioAPI{

    async hacerRequerimientoAxios(idClienteAFactPorConsultar) {
        const baseUrl =
            process.env.REACT_APP_API_SERVER +
            "/facturacion/clientesAFacturar/" +
            idClienteAFactPorConsultar;
        const respAxios = await axios({
            method: "get",
            url: baseUrl,
            data: null,
            headers: {
                "Content-Type": "application/json",
                // "Access-Control-Allow-Origin": "*",
                // "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
        });
        return respAxios;
    }

    getDataDeRespuestaAxiosExitosa(respAxiosExito){
        const respuestaApi = respAxiosExito.data;

        let dataDeActualizacionDeCliente;
        try {
            //parsear respuestaApi de tal manera que la data tenga el formato de exito correcto
            //Si hay error en parseo:
            // throw new ErrorDeApp.ErrorFormatoDeCom();
            dataDeActualizacionDeCliente = respuestaApi.data;
        } catch (error) {
            throw new Error.ErrorDeProtocoloDelServidor();
        }
        return dataDeActualizacionDeCliente;
    }

    lanzarErrorDeRespuestaAxiosErroneaDelComando(errorAxios) {}
}
// export default ServicioDeQueryDeUnClienteAFacturar ;
